module["exports"] = [
  "",
  "חדשה",
  "עלית"
];
